"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomUuid = exports.uuidFromString = exports.isUuid = void 0;
const uuid_1 = require("uuid");
const isUuid = (str) => {
    return (0, uuid_1.validate)(str);
};
exports.isUuid = isUuid;
const uuidFromString = (str) => {
    if ((0, exports.isUuid)(str)) {
        return str;
    }
    throw Error(`'${str}' is not a valid UUID.`);
};
exports.uuidFromString = uuidFromString;
const randomUuid = () => (0, exports.uuidFromString)((0, uuid_1.v4)());
exports.randomUuid = randomUuid;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXVpZC5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvdXVpZC5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFHYTtBQUlOLE1BQU0sTUFBTSxHQUFHLENBQUMsR0FBVyxFQUFlLEVBQUU7SUFDakQsT0FBTyxJQUFBLGVBQVEsRUFBQyxHQUFHLENBQUMsQ0FBQTtBQUN0QixDQUFDLENBQUE7QUFGWSxRQUFBLE1BQU0sVUFFbEI7QUFFTSxNQUFNLGNBQWMsR0FBRyxDQUFDLEdBQVcsRUFBUSxFQUFFO0lBQ2xELElBQUksSUFBQSxjQUFNLEVBQUMsR0FBRyxDQUFDLEVBQUU7UUFDZixPQUFPLEdBQUcsQ0FBQTtLQUNYO0lBRUQsTUFBTSxLQUFLLENBQUMsSUFBSSxHQUFHLHdCQUF3QixDQUFDLENBQUE7QUFDOUMsQ0FBQyxDQUFBO0FBTlksUUFBQSxjQUFjLGtCQU0xQjtBQUVNLE1BQU0sVUFBVSxHQUFHLEdBQVMsRUFBRSxDQUFDLElBQUEsc0JBQWMsRUFBQyxJQUFBLFNBQUUsR0FBRSxDQUFDLENBQUE7QUFBN0MsUUFBQSxVQUFVLGNBQW1DIn0=